import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { MediaImagesBlock, SectionContainer } from "@italymondo/core-ui";
import { Theme, Typography } from "@mui/material";
import ReactMarkdown from "markdown-to-jsx";

const baseParagraphContainer = (theme: Theme): SerializedStyles => css`
  ${theme.breakpoints.up("md")} {
    width: 600px;
  }
  margin-left: auto;
  margin-right: auto;
`;

export const ShadowHeaderParagraphContainer = styled("div")`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(4, "auto")};
    ${theme.breakpoints.up("md")} {
      width: 810px;
    }
  `}
`;

export const ShadowHeaderText = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.linearGradientText};
  `}
`;

export const TextParagraph = styled(ReactMarkdown)`
  ${({ theme }): SerializedStyles => css`
    ${baseParagraphContainer(theme)};
  `}
`;

export const StyledUL = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(4, 0)};
    list-style: none;
    li::before {
      content: "";
      background-color: ${theme.palette.primary.light};
      border-radius: 50%;
      display: inline-block;
      margin-right: ${theme.spacing(2)};
      height: ${theme.spacing(1)};
      width: ${theme.spacing(1)};
    }
  `}
`;

export const StyledOL = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(4, 0)};
  `}
`;

export const StyledP = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(2, 0)};
  `}
`;

export const StyledH1 = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(6, 0, 2)};
  `}
`;

export const StyledH2 = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(5, 0, 2)};
  `}
`;

export const StyledH3 = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    margin: ${theme.spacing(4, 0, 2)};
  `}
`;

export const SignatureBlockContainer = styled("div")`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.rowHCentered};
    > img,
    div {
      width: 400px;
      height: 100px;
    }
    margin: ${theme.spacing(8, "auto")};
  `}
`;

export const StreamfieldContainer = styled(SectionContainer)`
  ${({ theme }): SerializedStyles => css`
    padding-top: ${theme.spacing(4)} !important;
    ${theme.breakpoints.up("sm")} {
      padding-top: ${theme.spacing(8)} !important;
    }
  `}
`;

export const ImagesBlock = styled(MediaImagesBlock)`
  ${({ theme }): SerializedStyles => css`
    ${baseParagraphContainer(theme)};
    margin: ${theme.spacing(6, "auto", 8)};
  `}
`;
